module.exports = __webpack_public_path__ + "img/Infografis_ID_17.1459783c.jpg";